import { useSubscriptionQuery } from './api/useSubscriptionQuery';

export const useCheckout = () => {
  const queryInfo = useSubscriptionQuery();

  if (!queryInfo.data) {
    return queryInfo;
  }

  const {
    SubscriptionType,
    Interval,
    Price,
    TrialStart,
    TrialEnd,
    TrialPeriodDays,
  } = queryInfo.data;

  const data = {
    subscriptionType: SubscriptionType,
    interval: Interval,
    price: Price,
    trialStart: TrialStart,
    trialEnd: TrialEnd,
    trialPeriodDays: TrialPeriodDays,
  };

  return { ...queryInfo, data };
};
